export const baseInfo = `/api/unoauth/subcenter/getBaseinfo`;
export const selectCommittees = `/api/unoauth/subcenter/selectCommittees`; // 获取专家委员会列表
export const selectConstructionUnits = `/api/unoauth/subcenter/selectConstructionUnits`; // 获取共建单位列表
